import React from "react";
import { EVoucherAddToCusFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { portalService } from "apiServices";
import { Buttons, Icons, Inputs } from "components";

const EVoucherAddToCusForm = ({ onClose, onSubmit }) => {
  const schema = yup.object().shape({
    customer_ref_id: yup
      .object()
      .nullable()
      .required("กรุณาค้นหาใหม่ และ เลือกรายชื่อ"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <EVoucherAddToCusFormStyled>
      <div className="btn_close_wrap" onClick={onClose}>
        <Icons.CloseX />
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.InputCustomerAutoSuggestion
                {...field}
                label={"Redeem Customer"}
                apiService={portalService.GET_CUSTOMER_LIST}
                fieldRender={false}
                query={"?keyword"}
                errors={errors.customer_ref_id?.message}
              />
            )}
            name="customer_ref_id"
            // defaultValue=""
          />
        </div>

        <Buttons.BgStandard type="submit" label="Save" />
      </form>
    </EVoucherAddToCusFormStyled>
  );
};

EVoucherAddToCusForm.propTypes = {};

export default EVoucherAddToCusForm;
